import apiClient from "./axiosConfig";

// Get tags list with search and pagination
export const getTagsList = async (params = {}) => {
  try {
    const { search = '', page = 1, page_size = 25, batch_id } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    if (batch_id) queryParams.append('batch_id', batch_id);
    
    const response = await apiClient.get(`/products/unique-identifier/list/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create new tag
export const createTag = async (tagData) => {
  try {
    const formData = new FormData();
    formData.append('identifier', tagData.name);
    formData.append('description', tagData.description || '');
    
    if (tagData.image) {
      formData.append('image', tagData.image);
    }
    
    const response = await apiClient.post('/products/unique-identifier/create/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update tag
export const updateTag = async (tagId, tagData) => {
  try {
    const formData = new FormData();
    
    if (tagData.name !== undefined) {
      formData.append('identifier', tagData.name);
    }
    if (tagData.description !== undefined) {
      formData.append('description', tagData.description || '');
    }
    
    if (tagData.image) {
      formData.append('image', tagData.image);
    }
    
    const response = await apiClient.patch(`/products/unique-identifier/update/${tagId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete tag
export const deleteTag = async (tagId) => {
  try {
    const response = await apiClient.delete(`/products/unique-identifier/delete/${tagId}/`);
    if (response.status === 204) {
      return { success: true };
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get tag detail
export const getTagDetail = async (tagId) => {
  try {
    const response = await apiClient.get(`/products/unique-identifier/${tagId}/products/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get products by tag
export const getProductsByTag = async (tagId) => {
  try {
    const response = await apiClient.get(`/products/unique-identifier/${tagId}/products/?in_stock=1`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update selling price for tag products
export const updateTagSellingPrice = async (tagId, sellingPrice) => {
  try {
    const response = await apiClient.patch(`/products/unique-identifier/${tagId}/products/`, {
      selling_price: sellingPrice,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Detach product from tag
export const detachProductFromTag = async (productId) => {
  try {
    const response = await apiClient.post(`/products/unique-identifier/products/${productId}/detach/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
